export default __webpack_public_path__ + "static/media/capsule-draft-to-original.3f90823f.png";